import { AtualizarCompradorComNovoPaiMaeCommand } from '@/features/proposta/entities/Comprador/form-to-listagem/atualizar-comprador-com-novo-mae-pai-listagem-command'
import { AtualizarCompradorComNovoProcuradorCommand } from '@/features/proposta/entities/Comprador/form-to-listagem/atualizar-comprador-com-novo-procurador-listagem-command'
import { AtualizarCompradorComNovoRepresentanteLegalCommand } from '@/features/proposta/entities/Comprador/form-to-listagem/atualizar-comprador-com-novo-representante-legal-listagem-command'
import {
  AdicionarPessoaFisicaCommand,
  AtualizarPessoaFisicaCommand,
} from '@/features/proposta/entities/Comprador/form-to-listagem/comprador-pf-listagem-command'
import {
  AdicionarPessoaJuridicaCommand,
  AtualizarPessoaJuridicaCommand,
} from '@/features/proposta/entities/Comprador/form-to-listagem/comprador-pj-listagem-command'
import type {
  TCompradorPropostaSchema,
  TClientePessoaFisicaPropostaSchema,
  TClientePessoaJuridicaPropostaSchema,
  TProcuradorPropostaSchema,
} from '@/features/proposta/schemas'
import type {
  CompradorPessoaFisicaStepSchemaInput,
  CompradorVinculoStepSchemaInput,
} from '@/features/proposta/schemas/compradores/comprador-pf.schema'
import type { CompradorPessoaJuridicaSchemaInput } from '@/features/proposta/schemas/compradores/comprador-pj.schema'

export interface Command {
  executar: () => void
}

type TInput =
  | CompradorPessoaFisicaStepSchemaInput
  | CompradorPessoaJuridicaSchemaInput
  | CompradorVinculoStepSchemaInput

export type Dependencias = {
  adicionarCliente: (v: TClientePessoaFisicaPropostaSchema) => void
  atualizarCliente: (i: number, v: TClientePessoaFisicaPropostaSchema) => void
  adicionarClienteJuridico: (v: TClientePessoaJuridicaPropostaSchema) => void
  atualizarClienteJuridico: (i: number, v: TClientePessoaJuridicaPropostaSchema) => void
  adicionarComprador: (v: TCompradorPropostaSchema) => void
  atualizarComprador: (i: number, v: TCompradorPropostaSchema) => void
  adicionarProcurador: (procurador: TProcuradorPropostaSchema) => void
  atualizarProcurador: (i: number, procurador: TProcuradorPropostaSchema) => void
  removeCliente: (i: number) => void
}

export class CompradorListagemCommandFactory {
  static adicionar(
    comprador: TInput,
    deps: Dependencias,
    clientesPF: () => TClientePessoaFisicaPropostaSchema[],
    compradores: () => TCompradorPropostaSchema[],
    procuradores: () => TProcuradorPropostaSchema[],
  ): Command {
    switch (comprador.tipo) {
      case 'PessoaFisica': {
        return new AdicionarPessoaFisicaCommand(comprador, clientesPF, compradores, deps)
      }
      case 'PessoaJuridica':
        return new AdicionarPessoaJuridicaCommand(comprador, clientesPF, procuradores, deps)
      default:
        throw new Error(`Tipo não suportado: Cadastro comprador ${JSON.stringify(comprador)}`)
    }
  }

  static atualizar(
    comprador: TInput,
    deps: Dependencias,
    compradores: () => TCompradorPropostaSchema[],
    clientesPF: () => TClientePessoaFisicaPropostaSchema[],
    clientesPJ: () => TClientePessoaJuridicaPropostaSchema[],
    procuradores: () => TProcuradorPropostaSchema[],
    idToUpdate: string | null,
  ): Command {
    switch (comprador.tipo) {
      case 'PessoaFisica': {
        if (comprador.fluxoIndependente === 'MaePai') {
          return new AtualizarCompradorComNovoPaiMaeCommand(comprador, clientesPF, compradores, deps)
        }
        return new AtualizarPessoaFisicaCommand(comprador, clientesPF, compradores, procuradores, deps, idToUpdate)
      }
      case 'PessoaJuridica':
        return new AtualizarPessoaJuridicaCommand(comprador, clientesPJ, clientesPF, deps)
      case 'Procurador':
        return new AtualizarCompradorComNovoProcuradorCommand(clientesPF, procuradores, deps, comprador)
      case 'Representante':
        return new AtualizarCompradorComNovoRepresentanteLegalCommand(clientesPF, compradores, deps, comprador)
      default:
        throw new Error(`Tipo não suportado: Edição comprador ${JSON.stringify(comprador)}`)
    }
  }
}
